import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { successfullyAppliedPageCarousel } from '../../constants/MarketplaceConstants';
import { Carousel } from 'react-responsive-carousel';
import thumbsUp from '../../assets/thumbs_up.gif';
import specialist from '../../assets/specialist.svg';
import { useHistory } from 'react-router-dom';
import BottomButton from '../Buttons/BottomButton';

const SuccessfullyAppliedContainer = styled.div`
  height: 100%;
  .page-title {
    font-weight: 700;
    font-size: 22px;
    line-height: 30px;
    color: #d34b18;
  }

  .page-txt {
    margin-top: 16px;
    font-weight: 500;
    font-size: 17px;
    line-height: 23px;
    text-align: center;
    color: #555555;
  }

  .s1-img {
    margin-bottom: 40px;
  }

  .s2-img {
    margin-bottom: 40px;
  }

  .successfully-applied-carousel-parent-div {
    height: 85%;
    .carousel.carousel-slider {
      height: 100%;
      .control-dots {
        .dot {
          background-color: #dddddd !important;
          box-shadow: none !important;
        }
        .dot.selected {
          background-color: #d34612 !important;
          width: 14px !important;
          box-shadow: none !important;
        }
      }
    }
  }
`;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const SuccessfullyApplied = () => {
  const query = useQuery();
  const history = useHistory();
  const jobApplicationId = query.get('applicationId') ? query.get('applicationId') : '';
  const companyName = query.get('companyName') ? query.get('companyName') : '';
  const [currentSlide, setCurrentSlide] = useState(0);

  const changeSlides = () => {
    if (currentSlide < 1) {
      setCurrentSlide(1);
    } else if (currentSlide == 1) {
      history.replace(`/application-status?applicationId=${jobApplicationId}`);
    }
  };

  //   const updateCurrentSlide = index => {
  //     if (currentSlide == 0) {
  //       setCurrentSlide(currentSlide + 1);
  //     } else if (currentSlide == 1) {
  //       history.replace(`/application-status?applicationId=${jobApplicationId}`);
  //     }
  //   };

  return (
    <SuccessfullyAppliedContainer>
      <Carousel
        dynamicHeight={false}
        infiniteLoop={false}
        showStatus={false}
        showThumbs={false}
        autoPlay={false}
        interval={1000000}
        showIndicators={true}
        showArrows={false}
        selectedItem={currentSlide}
        className="successfully-applied-carousel-parent-div"
      >
        <div className="carousel-slide1">
          <div className="s1-img">
            <img src={thumbsUp} alt="" />
          </div>
          <div className="page-title">Good Job</div>

          <div className="page-txt">You have successfully applied for the {companyName} Job</div>
        </div>

        <div className="carousel-slide2">
          <div className="s2-img">
            <img src={specialist} alt="" />
          </div>
          <div className="page-title">Application Created</div>

          <div className="page-txt">
            Job specialist is ready. They are waiting for you to upload your documents
          </div>
        </div>
      </Carousel>

      <BottomButton buttonText="Continue" callBackFunction={() => changeSlides()} />
    </SuccessfullyAppliedContainer>
  );
};

export default SuccessfullyApplied;
